exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TuWCs5zf8iiMsA45YKJ9J{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap}html[dir=ltr] .TuWCs5zf8iiMsA45YKJ9J._1nk9LOGoYdlVx9QGmo5jOr button{margin-right:10px}html[dir=ltr] .TuWCs5zf8iiMsA45YKJ9J._3-JE0MmGiMpOPc3b8-1tNR button,html[dir=rtl] .TuWCs5zf8iiMsA45YKJ9J._1nk9LOGoYdlVx9QGmo5jOr button{margin-left:10px}html[dir=rtl] .TuWCs5zf8iiMsA45YKJ9J._3-JE0MmGiMpOPc3b8-1tNR button{margin-right:10px}", ""]);

// exports
exports.locals = {
	"workWeek": "TuWCs5zf8iiMsA45YKJ9J",
	"ltr": "_1nk9LOGoYdlVx9QGmo5jOr",
	"rtl": "_3-JE0MmGiMpOPc3b8-1tNR"
};